import {apiService} from '../apiService';
import type {FileReference, DocumentTemplate} from 'shared-types';

export interface DocumentSaveData {
    category: string;
    contractId?: string;
    customerId?: string;
    conflictResolution: 'rename' | 'overwrite';
    folderPath: string;
    description?: string;
}

export const documentApi = {
    // GET routes
    getById: (documentId: string): Promise<FileReference> =>
        apiService.get(`/document/id/${documentId}`),

    getVendorDocuments: (vendorId: string): Promise<FileReference[]> =>
        apiService.get(`/document/vendor/${vendorId}`),

    // POST routes - file uploads
    upload: (file: File): Promise<FileReference> =>
        apiService.uploadFile('/document', file),

    save: (file: File, data: DocumentSaveData): Promise<FileReference> =>
        apiService.uploadFile('/document/save', file, data),

    // DELETE routes
    delete: (documentId: string): Promise<void> =>
        apiService.delete(`/document/${documentId}`),

    // Document Template routes
    getTemplates: (): Promise<DocumentTemplate[]> =>
        apiService.get('/documents/document_template'),

    getTemplateById: (id: string): Promise<DocumentTemplate> =>
        apiService.get(`/documents/document_template/${id}`),

    createTemplate: (templateData: {newDocuments: any}): Promise<DocumentTemplate> =>
        apiService.post('/documents/document_template', templateData),

    updateTemplate: (id: string, templateData: any): Promise<DocumentTemplate> =>
        apiService.put(`/documents/document_template/${id}`, templateData),

    deleteTemplate: (id: string): Promise<DocumentTemplate> =>
        apiService.delete(`/documents/document_template/${id}`),

    previewTemplate: (id: string, variables: Record<string, string>): Promise<{renderedHtml: string}> =>
        apiService.post(`/documents/document_template/${id}/preview`, { variables }),
};